import { TeamplanPersonsT } from 'types/teamplan'
import { getTeamNameByLanguage } from 'types/utils'

export const getTeamplanPersonsName = (teamplanPersons: TeamplanPersonsT, language: string): string =>
  teamplanPersons.type === 'team' ? getTeamNameByLanguage(teamplanPersons.team, language) : teamplanPersons.name
